import { Col, Image, Row, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { Typography, Button, ResponsiveContainer } from '@sunday/component';
import Layout from '../../components/Layout';
import { config } from '../../config';
import style from './health.module.scss';
import cn from 'classnames';
import MarketingTypography from 'components/MarketingTypography/MarketingTypography';

const { ASSET_PREFIX } = config;
export const PartnerPageNameSpace = ['page.health'];

const UspCard = ({ src, title, body }: any) => (
  <div className={style.uspCard}>
    <Image
      src={src}
      preview={false}
      alt={title}
      style={{ width: "112px", height: "112px"}}
    />
    <Typography.Headline designLevel={2} weight='bold' className={style.title}>
      {title}
    </Typography.Headline>
    <Typography.Body designLevel={2} className={style.body}>
      {body}
    </Typography.Body>
  </div>
);

const ChooseUsItem = ({ src, body }: any) => (
  <div className={style.chooseUsItem}>
    <Image
      src={src}
      preview={false}
      alt={body}
      style={{ width: "112px", height: "112px"}}
    />
    <Typography.Body designLevel={2} className={style.body}>
      {body}
    </Typography.Body>
  </div>
);

const BenefitItem = ({ src, title, body }: any) => (
  <div className={style.benefitItem}>
    <Image
      src={src}
      preview={false}
      alt={title}
      style={{ width: "112px", height: "112px"}}
    />
    <Typography.Headline designLevel={2} weight='bold' className={style.title}>
      {title}
    </Typography.Headline>
    <Typography.Body designLevel={2} className={style.body}>
      {body}
    </Typography.Body>
  </div>
);

const Health = () => {
  const { t } = useTranslation(PartnerPageNameSpace);

  return (
    <Layout>
      <Row align='middle' gutter={24} className={style.heroBanner}>
        <Col xs={0} lg={24} style={{ height: '58px' }} />
        <Col xs={24} lg={0} style={{ height: '40px' }} />
        <Col xs={{ span: 20, offset: 2 }} sm={{ span: 10, offset: 4 }} lg={0} >
          <MarketingTypography.Display designLevel={3} weight='bold' className={style.white}>
            {t('tag-1')}<span className={cn(style.highlight)}>{t('tag-2')}</span> {t('tag-3')}
          </MarketingTypography.Display>
        </Col>
        <Col xs={0} sm={0} lg={{ span: 10, offset: 4 }} >
          <MarketingTypography.Display designLevel={2} weight='bold' className={style.white}>
            {t('tag-1')}<span className={cn(style.highlight)}>{t('tag-2')}</span> {t('tag-3')}
          </MarketingTypography.Display>
          <MarketingTypography.Title designLevel={1} weight='bold' className={style.white}>
            {t('headline-1')}
          </MarketingTypography.Title>
          <p/>
          <MarketingTypography.Title designLevel={3} className={style.white}>
            {t('headline-2')}
          </MarketingTypography.Title>
        </Col>
        <Col xs={24} sm={{ span: 6 }} lg={{ span: 8, offset: 0 }} style={{ textAlign: 'center' }}>
          <Image
            src={`${ASSET_PREFIX}/static/img/img-partner.svg`}
            preview={false}
            alt="hero-banner"
          />
        </Col>
        <Col xs={0} lg={24} style={{ height: '58px' }} />
        <Col xs={24} lg={0} style={{ height: '40px' }} />
      </Row>
      <div style={{ display: "flex", alignItems: "center", flexDirection: "column"}}>
      <ResponsiveContainer className={style.container}>
        <Row className={style.usp} align={"middle"}>
          <Col xl={24} xs={0} style={{ textAlign: 'center', marginBottom: "32px" }}>
            <Typography.Display designLevel={3} weight={"bold"} >
              {t('usp.title')}
            </Typography.Display>
            <Typography.Title designLevel={3} >
              {t('usp.body')}
            </Typography.Title>
          </Col>
          <Col xl={0} xs={24} style={{ textAlign: 'center', marginBottom: "32px" }}>
            <Typography.Headline designLevel={1} weight={"bold"} >
              {t('usp.title')}
            </Typography.Headline>
            <Typography.Title designLevel={3} >
              {t('usp.body')}
            </Typography.Title>
          </Col>
          <Row gutter={[16, 16]}>
            <Col xl={8} xs={24}>
              <UspCard
                src={`${ASSET_PREFIX}/static/img/img-usp-1.svg`}
                title={t('usp.coverage-1.title')}
                body={t('usp.coverage-1.body')}
              />  
            </Col>
            <Col xl={8} xs={24}>
              <UspCard
                src={`${ASSET_PREFIX}/static/img/img-usp-2.svg`}
                title={t('usp.coverage-2.title')}
                body={t('usp.coverage-2.body')}
              />  
            </Col>
            <Col xl={8} xs={24}>
              <UspCard
                src={`${ASSET_PREFIX}/static/img/img-usp-3.svg`}
                title={t('usp.coverage-3.title')}
                body={t('usp.coverage-3.body')}
              />  
            </Col>
            <Col xl={8} xs={24}>
              <UspCard
                src={`${ASSET_PREFIX}/static/img/img-usp-4.svg`}
                title={t('usp.coverage-4.title')}
                body={t('usp.coverage-4.body')}
              />  
            </Col>
            <Col xl={8} xs={24}>
              <UspCard
                src={`${ASSET_PREFIX}/static/img/img-usp-5.svg`}
                title={t('usp.coverage-5.title')}
                body={t('usp.coverage-5.body')}
              />  
            </Col>
            <Col xl={8} xs={24}>
              <UspCard
                src={`${ASSET_PREFIX}/static/img/img-usp-6.svg`}
                title={t('usp.coverage-6.title')}
                body={t('usp.coverage-6.body')}
              />  
            </Col>
            <Col xl={16} xs={24}>
              <UspCard
                src={`${ASSET_PREFIX}/static/img/img-usp-7.svg`}
                title={t('usp.coverage-7.title')}
                body={t('usp.coverage-7.body')}
              />  
            </Col>
            <Col xl={8} xs={24}>
              <UspCard
                src={`${ASSET_PREFIX}/static/img/img-usp-8.svg`}
                title={t('usp.coverage-8.title')}
                body={t('usp.coverage-8.body')}
              />  
            </Col>
          </Row>
        </Row>
      </ResponsiveContainer>
      </div>
      <Row className={style.chooseUs} gutter={48} align={"middle"} >
        <Col xs={24} xl={12}>
          <div style={{ display: 'flex', width: '200%'}}>
            <Image
              src={`${ASSET_PREFIX}/static/img/img-choose-us.png`}
              preview={false}
              alt={'choose-us'}
              style={{ width: "50%", height: "auto"}}
            />
          </div>
        </Col>
        <Col xs={24} xl={12} style={{ display: 'flex', flexDirection: 'column'}}>
          <MarketingTypography.Display designLevel={2} weight='bold' className={style.chooseUsTitle}>
            {t('choose-us.title-1')} <span className={style.highlight}>{t('choose-us.title-2')}</span> {t('choose-us.title-3')}
          </MarketingTypography.Display>
          <MarketingTypography.Headline designLevel={1} weight='bold' className={style.chooseUsTitleMobile}>
            {t('choose-us.title-1')} <span className={style.highlight}>{t('choose-us.title-2')}</span> {t('choose-us.title-3')}
          </MarketingTypography.Headline>
          <MarketingTypography.Title designLevel={3} className={style.chooseUsBody}>
            {t('choose-us.body')}
          </MarketingTypography.Title>
          <Row gutter={12}>
            <Col xs={24} xl={8}>
              <ChooseUsItem
                src={`${ASSET_PREFIX}/static/img/img-choose-us-1.svg`}
                body={t('choose-us.benefits.choose-us-1')}
              />  
            </Col>
            <Col xs={24} xl={8}>
              <ChooseUsItem
                src={`${ASSET_PREFIX}/static/img/img-choose-us-2.svg`}
                body={t('choose-us.benefits.choose-us-2')}
              />  
            </Col>
            <Col xs={24} xl={8}>
              <ChooseUsItem
                src={`${ASSET_PREFIX}/static/img/img-choose-us-3.svg`}
                body={t('choose-us.benefits.choose-us-3')}
              />  
            </Col>
          </Row>
        </Col>
      </Row>
      <div style={{ display: "flex", alignItems: "center", flexDirection: "column"}}>
        <ResponsiveContainer className={style.container}>
          <Row className={style.benefit} align='middle'>
            <Col xs={0} xl={24}>
              <Typography.Display designLevel={3} weight='bold' >
                {t('benefit.title')}
              </Typography.Display>
            </Col>
            <Col xs={24} xl={0}>
              <Typography.Headline designLevel={1} weight='bold' >
                {t('benefit.title')}
              </Typography.Headline>
            </Col>
            <Typography.Title designLevel={3}  >
              {t('benefit.body')}
            </Typography.Title>
          </Row>
          <Row gutter={64}>
            <Col xl={2} xs={0} />
            <Col xl={4} xs={24}>
              <BenefitItem
                src={`${ASSET_PREFIX}/static/img/img-benefit-1.svg`}
                title={t('benefit.items.item-1.title')}
                body={t('benefit.items.item-1.body')}
              />  
            </Col>
            <Col xl={4} xs={24}>
              <BenefitItem
                src={`${ASSET_PREFIX}/static/img/img-benefit-2.svg`}
                title={t('benefit.items.item-2.title')}
                body={t('benefit.items.item-2.body')}
              />  
            </Col>
            <Col xl={4} xs={24}>
              <BenefitItem
                src={`${ASSET_PREFIX}/static/img/img-benefit-3.svg`}
                title={t('benefit.items.item-3.title')}
                body={t('benefit.items.item-3.body')}
              />  
            </Col>
            <Col xl={4} xs={24}>
              <BenefitItem
                src={`${ASSET_PREFIX}/static/img/img-benefit-4.svg`}
                title={t('benefit.items.item-4.title')}
                body={t('benefit.items.item-4.body')}
              />  
            </Col>
            <Col xl={4} xs={24}>
            <BenefitItem
                src={`${ASSET_PREFIX}/static/img/img-benefit-5.svg`}
                title={t('benefit.items.item-5.title')}
                body={t('benefit.items.item-5.body')}
              />  
            </Col>
            <Col xl={2} xs={0} />
          </Row>
        </ResponsiveContainer>
      </div>
    </Layout>
  );
};

export default Health;
